// tog‘a #2065 W1 (2026-09-15): butun ilova bo‘yicha BITTA skaner tinglovchisi — AppLayout da bir marta ulanadi (sarlavhada emas: Header har jadvalda takrorlanadi).
// Qurilma-skaner kodi → eng ustki ochiq forma (reestr) → GET Residues/Scan (forma ombori bilan) → bitta tovar/partiya — darhol (S2), ko‘p — tanlash oynasi.
// Sarlavhadagi «Сканер» tugmasi `crm-open-scanner` hodisasi bilan shu yerdagi YAGONA GlobalScanner oynasini ochadi.
import React, { useContext, useEffect, useRef, useState } from "react"
import { message } from "antd"
import { useTranslation } from "react-i18next"
import { request } from "../../utils/config"
import { startScanDetector } from "./scanDetector"
import { pickScanTarget, ScanTarget } from "./scanRegistry"
import ScanPickModal from "./ScanPickModal"
import GlobalScanner from "./GlobalScanner"
import type { ScanItem } from "./scanTypes"
import { SocketContext } from "../../contexts/SocketContext"   // tog'a #2537: telefon — simsiz skaner

interface PickState {
  code: string
  items: ScanItem[]
  target: ScanTarget
}

export default function GlobalScanListener() {
  const { t } = useTranslation()
  const [pick, setPick] = useState<PickState | null>(null)
  const [scannerOpen, setScannerOpen] = useState(false)
  const pickRef = useRef<PickState | null>(null)
  pickRef.current = pick
  const scannerRef = useRef(false)
  scannerRef.current = scannerOpen
  const busyRef = useRef(false)
  const tRef = useRef(t)
  tRef.current = t
  const onCodeRef = useRef<((code: string) => void) | null>(null)
  const { lastMessage } = useContext(SocketContext) || ({} as any)

  const deliver = (target: ScanTarget, item: ScanItem, batchNumber: string | undefined, code: string) => {
    target.onScan({ code, item, batchNumber, stock: Number(item.total || 0) })
  }

  useEffect(() => {
    const onCode = async (code: string) => {
      const tt = tRef.current
      if (scannerRef.current) return   // sarlavhadagi skaner oynasi ochiq — uning maydoni o‘zi o‘qiydi
      if (pickRef.current) {
        message.info(tt("scanFinishPick", "Сначала выберите товар в окне сканера"))
        return
      }
      const r = pickScanTarget()
      if (!r) {
        message.info(tt("scanNoTarget", "Откройте продажу, закупку, заказ, возврат или перевод — скан добавится в форму"))
        return
      }
      if ("blockedBy" in r) {
        message.info(tt("scanCloseWindow", "Сначала закройте открытое окно"))
        return
      }
      if (busyRef.current) return
      busyRef.current = true
      const target = r.target
      try {
        const wh = target.getWarehouseId?.()
        const res = await request({ url: "Residues/Scan", params: { code, ...(wh ? { warehouseId: wh } : {}) } })
        const items: ScanItem[] = res?.data?.items || []
        if (!items.length) {
          message.warning(tt("scanNotFound", "Товар не найден") + ": " + code)
          return
        }
        if (items.length === 1) {
          const it = items[0]
          const batches = it.batches || []
          if (target.needBatch && !it.exactBatch && batches.length > 1) {
            setPick({ code, items, target })   // bitta tovar, bir nechta partiya — partiya tanlanadi
            return
          }
          deliver(target, it, it.exactBatch || (batches.length === 1 ? batches[0].batchNumber : undefined), code)
          return
        }
        setPick({ code, items, target })   // bir nechta tovar (bir xil kod turli artikullarda) — tovar tanlanadi
      } catch (e: any) {
        const d = e?.response?.data
        message.warning((d?.message || tt("scanNotFound", "Товар не найден")) + ": " + code)
      } finally {
        busyRef.current = false
      }
    }
    onCodeRef.current = onCode
    // tog'a #2537: skan faqat ochiq nishon (forma, kassa) bo'lsa yoki fokus matn maydonida BO'LMASA ushlanadi —
    // aks holda kod foydalanuvchi turgan maydonga (shtrix-kod, qidiruv, filtr) tushadi
    const matnMaydoni = (el: Element | null) =>
      !!el && ((el instanceof HTMLInputElement && !["checkbox", "radio", "button", "submit"].includes(el.type)) || el instanceof HTMLTextAreaElement)
    const stop = startScanDetector((c) => {
      onCode(c)
    }, (active) => scannerRef.current || !!pickRef.current || !!pickScanTarget() || !matnMaydoni(active))
    const openScanner = () => setScannerOpen(true)
    window.addEventListener("crm-open-scanner", openScanner)
    return () => {
      stop()
      window.removeEventListener("crm-open-scanner", openScanner)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // tog'a #2537/#2593 (2026-09-24): TELEFON — SIMSIZ SKANER. Mobil ilovada skanerlangan kod (ScanRelay/Send) shu foydalanuvchining
  // oynasiga WebSocket bilan keladi va apparat skaneri kabi ishlaydi: ochiq forma/kassa bo'lsa — odatiy skan yo'li (tovar qo'shiladi);
  // aks holda fokusdagi matn maydoniga (qidiruv, shtrix-kod) yoziladi va Enter bosiladi.
  useEffect(() => {
    if (!lastMessage || lastMessage?.nameFunction !== "scanRelay") return
    const code = String(lastMessage?.code || "").trim()
    if (!code) return
    message.info("📱 " + code, 1.5)
    if (pickRef.current) { message.info(tRef.current("scanFinishPick", "Сначала выберите товар в окне сканера")); return }
    const el = document.activeElement
    const matn = !!el && ((el instanceof HTMLInputElement && !["checkbox", "radio", "button", "submit"].includes(el.type)) || el instanceof HTMLTextAreaElement)
    if (!scannerRef.current && pickScanTarget()) { onCodeRef.current?.(code); return }
    if (matn) {
      const inp = el as HTMLInputElement
      const setter = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(inp), "value")?.set
      setter?.call(inp, code)
      inp.dispatchEvent(new Event("input", { bubbles: true }))
      inp.dispatchEvent(new KeyboardEvent("keydown", { key: "Enter", code: "Enter", keyCode: 13, which: 13, bubbles: true } as any))
      return
    }
    onCodeRef.current?.(code)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastMessage])

  return (
    <>
      {pick && (
        <ScanPickModal
          open={!!pick}
          code={pick.code}
          items={pick.items}
          needBatch={!!pick.target.needBatch}
          onCancel={() => setPick(null)}
          onPick={(item, batchNumber) => {
            const p = pick
            setPick(null)
            if (p) deliver(p.target, item, batchNumber, p.code)
          }}
        />
      )}
      <GlobalScanner open={scannerOpen} onClose={() => setScannerOpen(false)} />
    </>
  )
}
